window.makeid = function() {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < 10; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
};

jQuery(function($) {
  // global default
  $.validator.setDefaults({
    highlight: function(element) {
      $(element).closest('.control').addClass('error');
    },
    errorPlacement: function(error, element) {
      if (element.prop('type') === 'checkbox') {
        error.insertAfter(element.closest('.control'));
      }
      else {
        error.insertAfter(element);
      }
    }
  });

  $.validator.addMethod('valueNotEquals', function(value, element, arg) {
    return arg !== value;
  }, 'Value must not equal arg.');

  // validation set-a-goal
  $.validator.addClassRules('set-a-goal-input', {
    required: true
  });

  // password verification
  $('form[name="update-password"]').validate({
    rules: {
      'pwd': {
        required: true
      },
      'log': {
        required: true
      }
    }
  });

  // create an account form
  $('form[name="create-an-account"]').validate({
    rules: {
      'email': {
        required: true
      },
      'confirm-email': {
        required: true,
        equalTo: '[name="email"]'
      },
      'first-name': {
        required: true
      },
      'last-name': {
        required: true
      },
      'organization-type': {
        required: true
      },
      'organization-name': {
        required: true
      },
      'title': {
        required: true
      },
      'education-setting': {
        required: true,
        minlength: 1
      },
      'city': {
        required: true
      },
      'country': {
        valueNotEquals: 'Select Country'
      },
      'agree-terms': {
        required: true
      },
      'receive-news': {
        required: false
      }
    }
  });

  $('form[name="edit-profile"]').validate({
    rules: {
      'first-name': {
        required: true
      },
      'last-name': {
        required: true
      },
      'organization-type': {
        required: true
      },
      'organization-name': {
        required: true
      },
      'title': {
        required: true
      },
      'education-setting': {
        required: true,
        minlength: 1
      },
      'city': {
        required: true
      },
      'country': {
        required: true
      },
      'agree-terms': {
        required: true
      },
      'receive-news': {
        required: true
      }
    }
  });

  // update password
  $('form[name="update-password"]').validate({
    rules: {
      'old-password': {
        required: true
      },
      'confirm-new-password': {
        required: true,
        equalTo: '[name="new-password"]'
      }
    }
  });

  if ($('#create-an-account-form').length) {
    $('#submit_results').hide();

    $('#create-an-account-form').submit(function(event) {
      event.preventDefault();
      $('#submit_results').hide();

      if (!$('#create-an-account-form').valid()) {
        return;
      }

      $('.ctct-email').val($('#email').val());
      $('[placeholder="firstname"]').val($('#first_name').val());
      $('[placeholder="lastname"]').val($('#last_name').val());
      $('[placeholder="company"]').val($('#organization_name').val());
      $('[placeholder="city"]').val($('[name="city"]').val());
      $('[placeholder="regstate"]').val($('#State').find(':selected').val());

      var formData = $('#create-an-account-form').serializeArray();

      function register() {
        $.ajax({
          cache: false,
          type: 'POST',
          url: '/wp-content/themes/casel/ajax-handler.php?method=register',
          data: formData,
          dataType: 'json'
        })
          .done(function(data) {
            window.scrollTo(0, 0);
            if (data.error) {
              $('#submit_results').show();
              $('#submit_results').text(data.error_message);
              $('.submitting').removeClass('submitting');
            }
            else if ($('#refer').val()) {
              window.location = $('#refer').val();
            }
            else {
              window.location = '/profile?registered=1';
            }
          }).catch(function(e) {
            window.scrollTo(0, 0);
            $('#submit_results').show();
            $('#submit_results').text('Error Processing Request');
            $('.submitting').removeClass('submitting');
          });
      }

      if ($('[name="receive-news"]').is(':checked')) {
        $('#create-an-account-form').addClass('submitting');
        $('.ctct-submit').trigger('click');
        $('.ctct-form').bind('reset', function() {
          register();
        });
      }

      else {
        $('#create-an-account-form').addClass('submitting');
        register();
      }
    });
  }

  // Edit account
  if ($('#edit-profile').length) {
    $('#submit_results').hide();

    $('form[name="edit-profile"]').on('submit', function(event) {
      event.preventDefault();
      $('#submit_results').hide();

      if (!$('form[name="edit-profile"]').valid()) {
        return;
      }

      var formData = $('form[name="edit-profile"]').serializeArray();
      var newFormData = [];
      if (formData.length) {
        var education_setting = [];
        formData.forEach(function(element) {
          if (element.name === 'education_setting') {
            education_setting.push(element.value);
          }
          else {
            newFormData.push(element);
          }
        });
        newFormData.push({ name: 'education_setting', value: education_setting });

        $.ajax({
          cache: false,
          type: 'POST',
          url: '/wp-content/themes/casel/ajax-handler.php?method=editAccount',
          data: newFormData,
          dataType: 'json'
        }).done(function(data) {
          window.scrollTo(0, 0);
          if (data.error) {
            $('.submitting').removeClass('submitting');
            $('#submit_results').show();
            $('#submit_results').text(data.error_message);
          }
          else {
            $('.submitting').removeClass('submitting');
            $('#submit_results').show();
            $('#submit_results').text('Profile Updated');
          }
        }).catch(function(e) {
          window.scrollTo(0, 0);
          $('.submitting').removeClass('submitting');
          $('#submit_results').show();
          $('#submit_results').text('Error Processing Request');
        });
      }
    });
  }

  if ($('#update-password').length) {
    $('#submit_results').hide();

    var isUpdateFormValid = function() {
      var passwordLength = 5;
      var areSamePasswords = $('.new-password').val() === $('.confirm-new-password').val();
      var areValidLengths = $('.new-password').val().length > passwordLength && $('.confirm-new-password').val().length > passwordLength;
      return !!areSamePasswords && !!areValidLengths;
    };

    $('form[name="update-password"]').on('submit', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $('#submit_results').hide();
      if (isUpdateFormValid()) {
        var formData = $('form[name="update-password"]').serializeArray();
        $.ajax({
          cache: false,
          type: 'POST',
          url: '/wp-content/themes/casel/ajax-handler.php?method=changePassword',
          data: formData,
          dataType: 'json'
        })
          .done(function(data) {
            window.scrollTo(0, 0);
            if (data.error) {
              $('.submitting').removeClass('submitting');
              $('#submit_results').show();
              $('#submit_results').text(data.error_message);
            }
            else {
              $('.submitting').removeClass('submitting');
              $('#submit_results, .ux-login-fix').show();
              $('#submit_results').text('Password Updated').addClass('updated-pass');
              $('.control-label, #confirm-new-password-error, .control-hos').hide();
              $('#confirm-new-password-error').addClass('hide-error');
            }
          }).catch(function(e) {
            window.scrollTo(0, 0);
            $('.submitting').removeClass('submitting');
            $('#submit_results').show();
            $('#submit_results').text('Error Processing Request');
          });
      }
      else {
        return false;
      }
    });
  }
});
